import { environment } from '../shared/config/app-config';

export class Constants {
  static readonly DATE_FMT = environment.dateForm;
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
  static readonly DATE_SHR = 'h:mm a';
  static readonly DATE_MON= 'dd/MMM/yyyy';
}